<template>
	<div class="container">
		<div class="unsubscribe">
			<h2 class="title">Unsubscribe from newsletter</h2>
			<form class="" @submit.prevent="unsubscribe()">
				<div class="form-group mb-3">
					<input required v-model="email" type="email"
						   class="form-control" id="email"
						   placeholder="Email">
				</div>
				<div class="">
					<button type="submit" class="btn-unsubscribe-newsletter">Unsubscribe</button>
				</div>
			</form>
		</div>
		<Flash ref="show"/>
	</div>
</template>

<script>
import {api} from "../mixins/axios";
import Flash from "../components/Flash";

export default {
	name: "Unsubscribe",
	components: {
		Flash
	},
	data(){
		return{
			email:"",
		}
	},
	methods: {
		async unsubscribe(){
			let data = {
				email: this.email,
			}

			try {
				const response = await api.post(`/feedback/newsletter_unsubscribe`, data);

				if(response.status === 200){
					localStorage.removeItem("newsletter")
					this.$refs.show.showFlashSuccess('You successfully unsubscribed');
					setTimeout(()=>{
						this.$router.push("/")
					}, 1500)

				}

			} catch (e) {
				this.$refs.show.showFlashError(e.response.data.msg);
			}
		}
	}
};
</script>
<style scoped lang="scss">
	.unsubscribe{
		padding-top: 25px;
		padding-bottom: 25px;
	}
	.form-control {
		margin-bottom: 0;
		font-size: 16px;
		line-height: 28px;
		letter-spacing: -0.02em;
		color: #6C6C74;
		background: #F6F6F6;
		border-radius: 2px;
		border: none;
		padding: 11px 15px;
		outline: none;
		box-shadow: unset;
		max-width: 300px;
	}
	.btn-unsubscribe-newsletter{
		@include btn-orange;
	}
</style>